import posthtml from 'posthtml/lib';
import { link, textComponent, transcludeContent } from './utils';
export const addViewInBrowser = (mjml, options, t) => {
  const landingPageUrl = options.landingPageUrl;
  if (!landingPageUrl) {
    return mjml;
  }
  const viewInBrowserComponent = {
    tag: 'mj-section',
    attrs: {
      padding: '18px 20px',
      'background-color': '#fff',
      'css-class': 'view-in-browser-section',
      'full-width': 'full-width'
    },
    content: [{
      tag: 'mj-column',
      attrs: {
        width: '100%'
      },
      content: [textComponent(transcludeContent(t('EMAIL.USER.VIEW_IN_BROWSER_NEW'), [link(landingPageUrl, 'view-in-browser-link')]))]
    }]
  };
  const viewInBrowser = tree => {
    tree.match({
      tag: 'mjml'
    }, mjmlNode => {
      if (!mjmlNode.content) {
        mjmlNode.content = [];
      }
      mjmlNode.content.forEach(child => {
        if (child.tag === 'mj-body') {
          if (!child.content) {
            child.content = [];
          }
          child.content.unshift(viewInBrowserComponent);
        }
      });
      return mjmlNode;
    });
  };
  const withViewInBrowser = posthtml([viewInBrowser]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withViewInBrowser.html;
};
//# sourceMappingURL=add-view-in-browser.js.map